//double and slider icons are always big
export default {
    methods: {
        isBigIcon(i) {
            if (typeof i != 'undefined' && typeof i.icon != 'undefined') {
                return i.icon.includes("-d-") || i.icon.includes("icon-slider");
            }
            return false;
        },
    }
  };